"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_1 = require("@angular/core");
var router_1 = require("@angular/router");
var password_reset_finish_service_1 = require("./password-reset-finish.service");
var operators_1 = require("rxjs/operators");
var PasswordResetFinishComponent = /** @class */ (function () {
    function PasswordResetFinishComponent(passwordResetFinishService, route, elementRef, renderer) {
        this.passwordResetFinishService = passwordResetFinishService;
        this.route = route;
        this.elementRef = elementRef;
        this.renderer = renderer;
        this.isLoading = false;
    }
    PasswordResetFinishComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.route.queryParams.pipe(operators_1.first()).subscribe(function (params) {
            _this.key = params['key'];
        });
        this.resetAccount = {};
        this.keyMissing = !this.key;
    };
    PasswordResetFinishComponent.prototype.ngAfterViewInit = function () {
        if (this.elementRef.nativeElement.querySelector('#password') != null) {
            // this.renderer.invokeElementMethod(this.elementRef.nativeElement.querySelector('#password'), 'focus', []);
        }
    };
    PasswordResetFinishComponent.prototype.finishReset = function () {
        var _this = this;
        this.doNotMatch = null;
        this.error = null;
        if (this.resetAccount.password !== this.confirmPassword) {
            this.doNotMatch = 'ERROR';
        }
        else {
            this.isLoading = true;
            this.passwordResetFinishService.save({
                token: this.key,
                password: this.resetAccount.password
            }).pipe(operators_1.first()).subscribe(function () {
                _this.success = 'OK';
                _this.isLoading = false;
            }, function () {
                _this.success = null;
                _this.isLoading = false;
                _this.error = 'ERROR';
            });
        }
    };
    return PasswordResetFinishComponent;
}());
exports.PasswordResetFinishComponent = PasswordResetFinishComponent;
